<template>
    <div class='container'>
        <div class='clause'>
            <!-- <h3 class='text text-center'>托管房屋信息提交</h3> -->
            <hr>

            <div class='trust-forms'>
                <div class='trust-form'>
                    <div class='form-name'>1.所在城市<span class='need'>*</span></div>
                    <div class='form-input'>
                        <div class='form-control middle'>
                            {{info.city ? info.city : '请选择'}}
                            <img src='@/assets/datepicker_down_icon@3x.png' class='form-control__icon'/>
                            <select v-model="info.city">
                                <option value="''" disabled>请选择</option>
                                <option v-for='(city, index) in cities' :key='`city-${index}`' :value='city'>
                                    {{city}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class='trust-form'>
                    <div class='form-name'>2.详细地址（精确到道路号）<span class='need'>*</span></div>
                    <div class='form-input'>
                        <input type='text' class='form-control' v-model='info.road'/>
                    </div>
                </div>
                <div class='trust-form'>
                    <div class='form-name'>3.户型（如：3室2厅1厨1卫）<span class='need'>*</span></div>
                    <div class='form-input'>
                        <input type='tel' class='form-control small' v-model="info.bed_count"/>
                        <span class='space'>室</span>
                        <input type='tel' class='form-control small' v-model="info.hall_count"/>
                        <span class='space'>厅</span>
                        <input type='tel' class='form-control small' v-model="info.kitchen_count"/>
                        <span class='space'>厨</span>
                        <input type='tel' class='form-control small' v-model="info.bathroom_count"/>
                        <span class='space'>卫</span>
                    </div>
                </div>
                <div class='trust-form'>
                    <div class='form-name'>4.房屋装修<span class='need'>*</span></div>
                    <div class='form-input'>
                        <div class='form-control middle'>
                            {{info.is_fit ? info.is_fit : '请选择'}}
                            <img src='@/assets/datepicker_down_icon@3x.png' class='form-control__icon'/>
                            <select v-model="info.is_fit">
                                <option value="''" disabled>请选择</option>
                                <option v-for='(decoration, index) in decorations' :key='`decoration-${index}`' :value='decoration'>
                                    {{decoration}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class='trust-form'>
                    <div class='form-name'>5.电梯<span class='need'>*</span></div>
                    <div class='form-input'>
                        <label v-for='elevator in elevators' :key='`elevator-${elevator.value}`' class='form-input__radio'>
                            <input name='elevator' type='radio' :value="elevator.value" v-model="info.is_elevator">
                            {{elevator.name}}
                        </label>
                    </div>
                </div>
                <div class='trust-form'>
                    <div class='form-name'>6.建筑面积（平米）<span class='need'>*</span></div>
                    <div class='form-input'>
                        <input type='tel' class='form-control' v-model="info.square_meter"/>
                    </div>
                </div>
                <div class='trust-form'>
                    <div class='form-name'>7.期望租金（月/元）<span class='need'>*</span></div>
                    <div class='form-input'>
                        <input type='tel' class='form-control' v-model="info.money"/>
                    </div>
                </div>
                <div class='trust-form'>
                    <div class='form-name'>8.称呼（我们应该如何称呼您）<span class='need'>*</span></div>
                    <div class='form-input'>
                        <input type='text' class='form-control' v-model='info.username'/>
                    </div>
                </div>
                <div class='trust-form'>
                    <div class='form-name'>9.手机号<span class='need'>*</span></div>
                    <div class='form-input'>
                        <input type='tel' class='form-control' v-model="info.phone"/>
                    </div>
                </div>
                <div class='trust-form'>
                    <div class='form-name'>10.微信号</div>
                    <div class='form-input'>
                        <input type='text' class='form-control' v-model="info.wechat"/>
                    </div>
                </div>
            </div>
        </div>

        <div class='submit-form' @click='verify'>提交</div>
    </div>
</template>

<script>
    import axios from 'axios'
    const weui = window.weui
    const API_URL = window.location.host == 'clause.zuber.im'
        ? 'https://apiservices.zuber.im'
        : 'http://services.api.zuker.im'

    export default {
        data () {
            return {
                cities: ['上海', '北京', '深圳', '广州', '杭州', '南京', '苏州', '成都', '武汉'],
                decorations: ['毛坯', '简单装修', '中等装修', '精装修', '豪华装修'],
                elevators: [{name: '有', value: 1}, {name: '无', value: 2}],
                info: {
                    city: '',
                    road: '',
                    bed_count: '',
                    hall_count: '',
                    kitchen_count: '',
                    bathroom_count: '',
                    is_fit: '',
                    is_elevator: 1,
                    square_meter: '',
                    money: '',
                    username: '',
                    wechat: '',
                    phone: ''
                }
            }
        },
        methods: {
            hint (context) {
                weui.alert(context)
            },
            verify () {
                if (this.info.city == '') {
                    this.hint('请选择”城市“')
                } else if (this.info.road == '') {
                    this.hint('请填写”详细地址“')
                } else if (this.info.bed_count === '' || this.info.hall_count === '' || this.info.kitchen_count === '' || this.info.bathroom_count === '') {
                    this.hint('请填写完整户型')
                } else if (this.info.is_fit == '') {
                    this.hint('请选择”房屋装修“')
                } else if (this.info.square_meter == '') {
                    this.hint('请填写”建筑面积“')
                } else if (this.info.money == '') {
                    this.hint('请填写”期望租金“')
                } else if (this.info.username == '') {
                    this.hint('请填写”称呼“')
                } else {
                    this.submit()
                }
            },
            submit () {
                const instance = axios.create({
                    baseURL: API_URL
                })
                weui.confirm('确认提交吗？', () => {
                    const loading = weui.loading('提交中...')
                    instance.post('/client/rooms/ask', this.info).then(() => {
                        loading.hide(() => {
                            weui.toast('提交成功！')
                        })
                    }, () => {
                        loading.hide((res) => {
                            weui.alert(res.result.msg)
                        })
                    })
                })
            }
        }
    }
</script>

